import React from 'react';
import type { ComponentType, SVGProps } from 'react';
import { cn } from '@/shared/utils';

type DepositInstructionIcon =
  | ComponentType<SVGProps<SVGSVGElement>>
  | React.ReactNode
  | string;

export function renderIcon({
  icon,
  alt,
  className,
}: {
  icon: DepositInstructionIcon;
  alt?: string;
  className?: string;
}) {
  if (!icon) {
    return null;
  }

  if (typeof icon === 'string') {
    return (
      <img
        src={icon}
        alt={alt || ''}
        className={cn('object-contain', className)}
      />
    );
  }

  if (typeof icon === 'function') {
    return React.createElement(icon as ComponentType<SVGProps<SVGSVGElement>>, {
      className,
    });
  }

  return icon;
}
